import { backendUrl } from '@/util/config';
import { baseCurrency } from '@/util/getCurrency';

export default async function isBlackFriday() {
    const bf = await fetch(`${backendUrl}/services/blackFriday/${baseCurrency}`, {
        method: 'GET',
        credentials: 'include',
      });
      if (bf.status < 300) {
        return await bf.json();
      } else {
        throw new Error('Could not get black friday ' + bf.status + ' ' + await bf.text())
      }
}